(function () {
  var surface = null;
  var stops = [];
  var ticking = false;
  var DEFAULT_TRANSITION_START = 0.72;
  var targets = {};

  if (
    document.body &&
    document.body.classList.contains("template-index") &&
    document.querySelector("[data-cd-surface-start]")
  ) {
    document.documentElement.classList.add("cd-home-surface-ready");
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function smoothstep(value) {
    var t = clamp(value, 0, 1);
    return t * t * (3 - 2 * t);
  }

  var SURFACE_DARKEST = parseColor("#151515");
  var HEADER_DARK = { r: 21, g: 21, b: 21 };
  var HEADER_DARK_CSS = colorToCss(HEADER_DARK);
  var HEADER_DARK_RGB = "21, 21, 21";

  function parseColor(input) {
    if (!input) return null;

    var value = String(input).trim();
    var hex = value.replace(/^#/, "");

    if (/^[0-9a-fA-F]{3}$/.test(hex)) {
      return {
        r: parseInt(hex.charAt(0) + hex.charAt(0), 16),
        g: parseInt(hex.charAt(1) + hex.charAt(1), 16),
        b: parseInt(hex.charAt(2) + hex.charAt(2), 16),
      };
    }

    if (/^[0-9a-fA-F]{6}$/.test(hex)) {
      return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4, 6), 16),
      };
    }

    var rgbMatch = value.match(/rgba?\(([^)]+)\)/i);
    if (rgbMatch) {
      var channels = rgbMatch[1].split(",").map(function (channel) {
        return parseFloat(channel.trim());
      });

      if (
        channels.length >= 3 &&
        channels.every(function (channel) {
          return !Number.isNaN(channel);
        })
      ) {
        return {
          r: clamp(Math.round(channels[0]), 0, 255),
          g: clamp(Math.round(channels[1]), 0, 255),
          b: clamp(Math.round(channels[2]), 0, 255),
        };
      }
    }

    return null;
  }

  function mixColor(from, to, progress) {
    return {
      r: Math.round(from.r + (to.r - from.r) * progress),
      g: Math.round(from.g + (to.g - from.g) * progress),
      b: Math.round(from.b + (to.b - from.b) * progress),
    };
  }

  function colorToCss(color) {
    return "rgb(" + color.r + ", " + color.g + ", " + color.b + ")";
  }

  function channelToLinear(channel) {
    var value = channel / 255;
    return value <= 0.04045
      ? value / 12.92
      : Math.pow((value + 0.055) / 1.055, 2.4);
  }

  function getLuminance(color) {
    var r = channelToLinear(color.r);
    var g = channelToLinear(color.g);
    var b = channelToLinear(color.b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  function standardizeSurfaceColor(color) {
    if (!color) return null;

    return getLuminance(color) < 0.35
      ? { r: 21, g: 21, b: 21 }
      : { r: 255, g: 255, b: 255 };
  }

  function getForegroundBlend(color) {
    var luminance = getLuminance(color);
    return smoothstep((0.68 - luminance) / 0.42);
  }

  function getForegroundColor(color) {
    return mixColor(
      { r: 17, g: 17, b: 17 },
      { r: 244, g: 244, b: 242 },
      getForegroundBlend(color),
    );
  }

  function getTransitionStartRatio(node) {
    var raw = parseFloat(node.getAttribute("data-cd-surface-transition-start"));
    if (!Number.isNaN(raw)) return clamp(raw, 0, 0.98);
    return DEFAULT_TRANSITION_START;
  }

  function getTransitionStartY(stop) {
    var range = Math.max(stop.bottom - stop.top, 1);
    var viewport = Math.max(window.innerHeight || 0, 1);
    var minWindow = Math.min(Math.max(viewport * 0.2, 140), range * 0.45);
    var start = stop.top + range * stop.transitionStartRatio;
    return Math.min(start, stop.bottom - minWindow);
  }

  function readStops() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll("[data-cd-surface-start]"),
    );

    stops = nodes
      .map(function (node) {
        var start = standardizeSurfaceColor(
          parseColor(node.getAttribute("data-cd-surface-start")),
        );
        if (!start) return null;

        return {
          node: node,
          start: start,
          explicitEnd: standardizeSurfaceColor(
            parseColor(node.getAttribute("data-cd-surface-end")),
          ),
          end: start,
          transitionStartRatio: getTransitionStartRatio(node),
          top: 0,
          bottom: 0,
        };
      })
      .filter(Boolean);

    stops.forEach(function (stop, index) {
      var next = stops[index + 1];
      stop.end = stop.explicitEnd || (next ? next.start : stop.start);
    });
  }

  function measureStops() {
    stops.forEach(function (stop) {
      var rect = stop.node.getBoundingClientRect();
      var top = rect.top + window.scrollY;
      var height = Math.max(rect.height, stop.node.offsetHeight || 0, 1);
      stop.top = top;
      stop.bottom = top + height;
    });
  }

  function findColor(anchor) {
    if (!stops.length) return null;

    if (anchor <= stops[0].top) {
      return stops[0].start;
    }

    for (var index = 0; index < stops.length; index += 1) {
      var stop = stops[index];

      if (anchor >= stop.top && anchor <= stop.bottom) {
        var transitionStart = getTransitionStartY(stop);
        var progress =
          (anchor - transitionStart) /
          Math.max(stop.bottom - transitionStart, 1);
        return mixColor(stop.start, stop.end, smoothstep(progress));
      }

      var next = stops[index + 1];
      if (next && anchor > stop.bottom && anchor < next.top) {
        var gapProgress =
          (anchor - stop.bottom) / Math.max(next.top - stop.bottom, 1);
        return mixColor(stop.end, next.start, smoothstep(gapProgress));
      }
    }

    return stops[stops.length - 1].end;
  }


  function getRevealProgress(node) {
    if (!node) return 0;

    var rect = node.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var travel = Math.max(node.offsetHeight - viewportHeight, 1);
    var start = parseFloat(node.getAttribute("data-cd-reveal-start") || "0.18");
    var end = parseFloat(node.getAttribute("data-cd-reveal-end") || "0.96");

    if (Number.isNaN(start)) start = 0.18;
    if (Number.isNaN(end)) end = 0.96;

    var overallProgress = clamp((-rect.top) / travel, 0, 1);
    return clamp(
      (overallProgress - start) / Math.max(end - start, 0.01),
      0,
      1,
    );
  }

  function getRevealSurfaceColor() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll("[data-cd-surface-reveal-threshold]"),
    );

    if (!nodes.length) return null;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var chosen = null;

    nodes.forEach(function (node) {
      var rect = node.getBoundingClientRect();
      if (rect.top >= viewportHeight || rect.bottom <= 0) return;

      var start = standardizeSurfaceColor(
        parseColor(node.getAttribute("data-cd-surface-start")),
      );
      var end = standardizeSurfaceColor(
        parseColor(node.getAttribute("data-cd-surface-end")),
      );
      if (!start || !end) return;

      var revealProgress = getRevealProgress(node);

      /*
        Dark-intro reveal sections are visually special: the bright shop layer
        is already visible through a clipped oval while the viewport anchor can
        still technically be inside the dark pinned section. Let that reveal
        progress control the global surface so the page stays dark until the
        oval is almost open, then becomes light before the next light section
        reaches the viewport center.
      */
      if (revealProgress <= 0 && rect.top > 0) return;

      var threshold = parseFloat(
        node.getAttribute("data-cd-surface-reveal-threshold") || "0.9",
      );
      var blendWindow = parseFloat(
        node.getAttribute("data-cd-surface-reveal-blend") || "0.035",
      );

      if (Number.isNaN(threshold)) threshold = 0.9;
      if (Number.isNaN(blendWindow)) blendWindow = 0.035;

      threshold = clamp(threshold, 0, 0.99);
      blendWindow = clamp(blendWindow, 0.001, 1);

      chosen = mixColor(
        start,
        end,
        smoothstep((revealProgress - threshold) / blendWindow),
      );
    });

    return chosen;
  }

  function collectNodes(selector, filter) {
    return Array.prototype.slice
      .call(document.querySelectorAll(selector))
      .filter(function (node) {
        return !filter || filter(node);
      });
  }

  function isMorphableTextNode(node) {
    if (!node) return false;
    if (
      node.closest(
        'button, [role="button"], .button, .btn, .cd-home-hero__button, .cd-home-merged__hero-button, .cd-home-merged__product-button, .cd-dark-shop__button, .cd-home-refills__button, .cd-rec-product__button, .cd-home-footer__subscribe',
      )
    ) {
      return false;
    }
    return true;
  }

  function collectTargets() {
    targets = {
      header: document.querySelector("[data-cd-hero-header]"),
      headerLogos: collectNodes(
        "[data-cd-hero-header] .cd-hero-header__logo img, [data-cd-hero-header] .cd-hero-header__mobile-logo img",
      ),
      headerText: collectNodes(
        "[data-cd-hero-header] .cd-hero-header__nav-link, [data-cd-hero-header] .cd-hero-header__cart-link, [data-cd-hero-header] .cd-hero-header__menu-trigger, [data-cd-hero-header] .t4s-push-menu-btn, [data-cd-hero-header] .cd-hero-header__cart-count",
      ),
      headerIcons: collectNodes(
        '[data-cd-hero-header] svg, [data-cd-hero-header] svg *, [data-cd-hero-header] [class*="icon"]',
      ),
      heroes: collectNodes(".cd-home-hero"),
      merged: collectNodes(".cd-home-merged"),
      darkIntros: collectNodes(".cd-home-dark-intro"),
      darkShops: collectNodes(".cd-home-dark-shop"),
      refills: collectNodes(".cd-home-refills"),
      stories: collectNodes(".cd-home-story"),
      quality: collectNodes(".cd-quality-materials"),
      storyTimes: collectNodes(".cd-story-time"),
      journals: collectNodes(".journal-section"),
      footers: collectNodes(".cd-home-footer"),
      recommendedProducts: collectNodes(".cd-rec-product"),
      primaryText: collectNodes(
        '.cd-home-hero :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .cd-home-merged :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .cd-home-dark-intro :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .cd-home-dark-shop :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .cd-home-refills :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .cd-home-story :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .cd-quality-materials :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .cd-story-time :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .journal-section :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .cd-home-footer :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"]), .cd-rec-product :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"])',
        isMorphableTextNode,
      ),
      mutedText: collectNodes(
        '.cd-home-merged [class*="compare"], .cd-home-merged [class*="muted"], .cd-home-dark-intro [class*="compare"], .cd-home-dark-intro [class*="muted"], .cd-home-dark-shop [class*="compare"], .cd-home-dark-shop [class*="muted"], .cd-home-refills [class*="compare"], .cd-home-refills [class*="muted"], .cd-story-time [class*="caption"], .cd-story-time [class*="muted"], .journal-section .t4s-post-metas, .journal-section .t4s-post-content, .journal-section .t4s-post-author__text, .journal-section .t4s-post-time__text, .cd-home-footer .cd-home-footer__subcopy, .cd-home-footer .cd-home-footer__legal, .cd-home-footer .cd-home-footer__copyright, .cd-rec-product [class*="compare"], .cd-rec-product [class*="muted"]',
      ),
      lineNodes: collectNodes(
        ".cd-story-time__line, .cd-story-time__tile, .cd-home-footer__newsletter-input, .cd-home-footer__social-link, .cd-home-footer__menu a",
      ),
      footerFields: collectNodes(
        ".cd-home-footer__newsletter-input input, .cd-home-footer__newsletter-input textarea",
      ),
      genericPrimaryText: collectNodes(
        '#MainContent .shopify-section :is(h1, h2, h3, h4, h5, h6, p, span, a, small, strong, em, li, dt, dd, label, blockquote, cite, [class*="title"], [class*="heading"], [class*="copy"], [class*="body"], [class*="caption"], [class*="eyebrow"], [class*="description"], [class*="content"], [class*="price"], [class*="rating"], [class*="meta"], [class*="side"], [class*="subheading"], [class*="subtitle"], [class*="text"])',
        function (node) {
          if (!isMorphableTextNode(node)) return false;
          if (node.closest("input, textarea, select, option, summary, svg"))
            return false;
          return true;
        },
      ),
      genericMutedText: collectNodes(
        '#MainContent .shopify-section :is([class*="meta"], [class*="date"], [class*="excerpt"], [class*="caption"], [class*="muted"], [class*="subtext"], [class*="subtitle"], [class*="eyebrow"])',
        function (node) {
          return !node.closest(
            'button, [role="button"], .button, .btn, input, textarea, select, option, summary, svg',
          );
        },
      ),
    };
  }

  function setPropertyOnNodes(nodes, property, value) {
    if (!nodes || !nodes.length) return;
    nodes.forEach(function (node) {
      node.style.setProperty(property, value);
    });
  }

  function setInlineColor(nodes, value) {
    if (!nodes || !nodes.length) return;
    nodes.forEach(function (node) {
      if (node && node.style.color !== value) {
        node.style.color = value;
      }
    });
  }

  function setInlineBorderColor(nodes, value) {
    if (!nodes || !nodes.length) return;
    nodes.forEach(function (node) {
      if (node && node.style.borderColor !== value) {
        node.style.borderColor = value;
      }
    });
  }

  function getNumberCssVar(node, property) {
    if (!node || !window.getComputedStyle) return 0;

    var parsed = parseFloat(
      window.getComputedStyle(node).getPropertyValue(property),
    );

    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function isSectionActuallyUnderHeader(section, header) {
    if (!section || !header || typeof document.elementsFromPoint !== "function") {
      return true;
    }

    var headerRect = header.getBoundingClientRect();
    var probeY = Math.max(
      0,
      Math.min(window.innerHeight - 1, Math.round(headerRect.bottom - 2)),
    );
    var probeXs = [0.18, 0.5, 0.82].map(function (ratio) {
      return Math.max(
        0,
        Math.min(window.innerWidth - 1, Math.round(window.innerWidth * ratio)),
      );
    });

    for (var x = 0; x < probeXs.length; x += 1) {
      var stack = document.elementsFromPoint(probeXs[x], probeY);

      for (var i = 0; i < stack.length; i += 1) {
        var node = stack[i];
        if (!node || node === document.documentElement || node === document.body) {
          continue;
        }

        if (header.contains(node) || (node.closest && node.closest("[data-cd-hero-header]"))) {
          continue;
        }

        var owner = node.closest
          ? node.closest(".cd-home-dark-intro[data-cd-surface-reveal-threshold]")
          : null;
        if (owner === section) return true;

        if (node.closest && node.closest("#MainContent .shopify-section, main .shopify-section")) {
          return false;
        }
      }
    }

    return false;
  }

  function isRevealLightTouchingHeader() {
    var header = targets.header || document.querySelector("[data-cd-hero-header]");
    if (!header || !window.getComputedStyle) return false;

    var headerRect = header.getBoundingClientRect();
    if (headerRect.bottom <= 0) return false;

    var revealSections = Array.prototype.slice.call(
      document.querySelectorAll(
        ".cd-home-dark-intro[data-cd-surface-reveal-threshold]",
      ),
    );

    return revealSections.some(function (section) {
      if (!isSectionActuallyUnderHeader(section, header)) return false;

      var progress = getNumberCssVar(section, "--cd-dark-reveal-progress");
      var ry = getNumberCssVar(section, "--cd-dark-reveal-ry");
      if (progress <= 0.01 || ry <= 0) return false;

      var sticky =
        section.querySelector(".cd-home-dark-intro__sticky") || section;
      var rect = sticky.getBoundingClientRect();
      var viewport = Math.max(window.innerHeight || 0, 1);

      if (rect.bottom <= 0 || rect.top >= viewport) return false;

      var centerY = rect.top + rect.height * 0.5;
      var ovalTop = centerY - ry;
      var ovalBottom = centerY + ry;

      return ovalTop <= headerRect.bottom + 1 && ovalBottom >= headerRect.top;
    });
  }

  function applyForegroundOverrides(
    foregroundCss,
    foregroundRgb,
    mutedCss,
    lineCss,
    lineStrongCss,
    invertAmount,
  ) {
    var forceDarkHeader = isRevealLightTouchingHeader();
    var headerCss = forceDarkHeader ? HEADER_DARK_CSS : foregroundCss;
    var headerRgb = forceDarkHeader ? HEADER_DARK_RGB : foregroundRgb;
    var headerInvertAmount = forceDarkHeader ? "0" : invertAmount;

    if (targets.header) {
      targets.header.style.color = headerCss;
      targets.header.style.setProperty("--h-text-color", headerCss);
      targets.header.style.setProperty("--h-text-color-rgb", headerRgb);
      targets.header.style.setProperty(
        "--h-text-color-hover",
        "rgba(" + headerRgb + ", 0.78)",
      );
    }

    setInlineColor(targets.headerText, headerCss);
    if (targets.headerIcons && targets.headerIcons.length) {
      targets.headerIcons.forEach(function (node) {
        node.style.color = headerCss;
        if (node.tagName && node.tagName.toLowerCase() !== "svg") {
          node.style.stroke = "currentColor";
          if (
            node.getAttribute &&
            node.getAttribute("fill") &&
            node.getAttribute("fill") !== "none"
          ) {
            node.style.fill = "currentColor";
          }
        }
      });
    }

    if (targets.headerLogos && targets.headerLogos.length) {
      var headerLogoFilter =
        "invert(" + headerInvertAmount + ") brightness(1.02)";
      targets.headerLogos.forEach(function (node) {
        node.style.filter = headerLogoFilter;
      });
    }

    setPropertyOnNodes(targets.heroes, "--cd-hero-text", foregroundCss);
    setInlineColor(targets.heroes, foregroundCss);

    setPropertyOnNodes(targets.merged, "--cd-merged-text", foregroundCss);
    setInlineColor(targets.merged, foregroundCss);

    setPropertyOnNodes(
      targets.darkIntros,
      "--cd-dark-intro-text",
      foregroundCss,
    );
    setPropertyOnNodes(
      targets.darkIntros,
      "--cd-dark-shop-text",
      foregroundCss,
    );
    setInlineColor(targets.darkIntros, foregroundCss);
    setInlineColor(targets.darkShops, foregroundCss);

    setPropertyOnNodes(targets.refills, "--cd-refills-text", foregroundCss);
    setPropertyOnNodes(targets.refills, "--cd-refills-text-muted", mutedCss);
    setInlineColor(targets.refills, foregroundCss);

    setPropertyOnNodes(targets.stories, "--cd-story-fg", foregroundCss);
    setInlineColor(targets.stories, foregroundCss);

    setInlineColor(targets.quality, foregroundCss);

    setPropertyOnNodes(
      targets.storyTimes,
      "--cd-story-time-text",
      foregroundCss,
    );
    setPropertyOnNodes(
      targets.storyTimes,
      "--cd-story-time-flow-text",
      foregroundCss,
    );
    setPropertyOnNodes(
      targets.storyTimes,
      "--cd-story-time-flow-body",
      mutedCss,
    );
    setPropertyOnNodes(targets.storyTimes, "--cd-story-time-line", lineCss);
    setPropertyOnNodes(
      targets.storyTimes,
      "--cd-story-time-tile-border",
      lineStrongCss,
    );
    setPropertyOnNodes(
      targets.storyTimes,
      "--cd-story-time-tile-text",
      foregroundCss,
    );
    setInlineColor(targets.storyTimes, foregroundCss);

    setPropertyOnNodes(targets.journals, "--secondary-color", foregroundCss);
    setPropertyOnNodes(targets.journals, "--text-color", mutedCss);
    setPropertyOnNodes(targets.journals, "--border-color", lineStrongCss);
    setInlineColor(targets.journals, foregroundCss);

    setInlineColor(targets.footers, foregroundCss);
    setInlineColor(targets.recommendedProducts, foregroundCss);
    setInlineColor(targets.primaryText, foregroundCss);
    setInlineColor(targets.mutedText, mutedCss);
    setInlineColor(targets.genericPrimaryText, foregroundCss);
    setInlineColor(targets.genericMutedText, mutedCss);
    setInlineColor(targets.footerFields, foregroundCss);
    setInlineBorderColor(targets.lineNodes, lineStrongCss);
  }

  function clampSurfaceFloor(color, floor) {
    return {
      r: Math.max(color.r, floor.r),
      g: Math.max(color.g, floor.g),
      b: Math.max(color.b, floor.b),
    };
  }

  function applyColor(color) {
    if (!surface || !color) return;

    var cssValue = colorToCss(color);
    var foreground = getForegroundColor(color);
    var foregroundCss = colorToCss(foreground);
    var foregroundRgb =
      foreground.r + ", " + foreground.g + ", " + foreground.b;
    var hoverCss = "rgba(" + foregroundRgb + ", 0.78)";
    var mutedCss = colorToCss(mixColor(foreground, color, 0.34));
    var invertAmount = getForegroundBlend(color).toFixed(3);
    var lineCss = "rgba(" + foregroundRgb + ", 0.16)";
    var lineStrongCss = "rgba(" + foregroundRgb + ", 0.24)";

    if (surface.dataset.cdSurfaceColor !== cssValue) {
      surface.dataset.cdSurfaceColor = cssValue;
      surface.style.backgroundColor = cssValue;
      document.documentElement.style.setProperty(
        "--cd-home-surface-color",
        cssValue,
      );
    }

    if (surface.dataset.cdSurfaceForeground !== foregroundCss) {
      surface.dataset.cdSurfaceForeground = foregroundCss;
      document.documentElement.style.setProperty(
        "--cd-home-surface-fg",
        foregroundCss,
      );
      document.documentElement.style.setProperty(
        "--cd-home-surface-fg-rgb",
        foregroundRgb,
      );
      document.documentElement.style.setProperty(
        "--cd-home-surface-fg-hover",
        hoverCss,
      );
      document.documentElement.style.setProperty(
        "--cd-home-surface-fg-muted",
        mutedCss,
      );
      document.documentElement.style.setProperty(
        "--cd-home-surface-logo-invert",
        invertAmount,
      );
    }

    applyForegroundOverrides(
      foregroundCss,
      foregroundRgb,
      mutedCss,
      lineCss,
      lineStrongCss,
      invertAmount,
    );
  }

  function update() {
    if (!surface || !stops.length) {
      ticking = false;
      return;
    }

    var anchor = window.scrollY + window.innerHeight * 0.5;
    var revealColor = getRevealSurfaceColor();
    var blended = revealColor || findColor(anchor);

    applyColor(clampSurfaceFloor(blended, SURFACE_DARKEST));
    ticking = false;
  }

  function queueUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function rebuild() {
    surface = document.getElementById("cd-home-surface-canvas");
    if (!surface) return;
    document.documentElement.classList.add("cd-home-surface-ready");
    readStops();
    measureStops();
    collectTargets();
    queueUpdate();
  }

  document.addEventListener("DOMContentLoaded", rebuild);
  window.addEventListener("load", rebuild);
  window.addEventListener("resize", rebuild);
  window.addEventListener("orientationchange", rebuild);
  window.addEventListener("scroll", queueUpdate, { passive: true });
  document.addEventListener("shopify:section:load", rebuild);
  document.addEventListener("shopify:section:reorder", rebuild);
  document.addEventListener("shopify:section:unload", rebuild);

  window.CDCleerSurfaceBlend = {
    refresh: rebuild,
    update: queueUpdate,
  };
})();
